export const topCsls = [
  { key: "pvancouver", value: "شیوه Vancouver چند زبانه" },
  {
    key: "pelsevier-harvard2",
    value: "شیوه Elsevier - Harvard چند زبانه، نسخه ۲",
  },
  { key: "pamieee", value: "شیوه IEEE چند زبانه" },
  { key: "papa", value: "شیوه APA چند زبانه، نسخه ۶" },
  {
    key: "pchicago-author-date-ed17",
    value: "شیوه (Chicago (author-date چند زبانه، نسخه ۱۷",
  },
  {
    key: "pchicago-fullnote-bibliography-with-ibid-ed17",
    value: "شیوه (Chicago (footnote-bibliography چند زبانه، نسخه ۱۷",
  },
  {
    key: "pmodern-language-association-8th-edition",
    value: "شیوه MLA چند زبانه، نسخه ۸",
  },
];
